<template>
  <Row style="padding: 20px">
    <Col span="24" style="margin-bottom: 20px">
      <Select class="public-inp" v-model="params.platformCode" placeholder="请选择所属平台">
        <Option v-for="e in platformList" :value="e.code" :key="e.code">{{
          e.name
        }}</Option>
      </Select>
      <Select class="public-inp" v-model="params.retCode">
        <Option
          v-for="item in shopInfoQueryList.data || []"
          :key="item.retCode"
          :value="item.retCode"
          >{{ item.retName || item.retCode }}</Option
        >
      </Select>
      <Button type="primary" icon="md-search" @click="getList" v-access="'wallet.cash.query'">搜索</Button>
      <Button @click="resetList"  v-access="'wallet.cash.reset'">重置</Button>
    </Col>
    <Col span="24">
      <Table
        class="table"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="shopWalletList.data || []"
      >
        <template slot-scope="{ index }" slot="no">
          <span>{{ params.pageSize * (params.page - 1) + index + 1 }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a style="margin-right: 5px" @click="detail(row, index)">查看</a>
          <a
            type="text"
            size="small"
            style="margin-right: 5px"
            @click="edit(row, index)"
            >编辑</a
          >
          <a style="margin-right: 5px" @click="deletehandler(row, index)"
            >删除</a
          >
        </template>
      </Table>
      <Page
        :style="{ float: 'right', marginTop: '10px' }"
        :total="shopWalletList.total"
        show-sizer
        show-total
        prev-text="Previous"
        next-text="Next"
        show-elevator
        @on-change="pageNumChange"
        @on-page-size-change="pageSizeChange"
      />
    </Col>
  </Row>
</template>
<script>
import { mapGetters } from "vuex";
const columns = [
  {
    title: "序号",
    slot: "no",
    width: 80,
  },
  // {
  //   title: "类型",
  //   key: "stype",
  // },
  {
    title: "平台编码",
    key: "platformName",
  },
  {
    title: "门店名称",
    key: "retName",
  },
  {
    title: "余额",
    key: "amount",
  },
  // {
  //   title: "活动返利余额",
  //   key: "activityAmount",
  // },
  // {
  //   title: "销售返利余额",
  //   key: "saleAmount",
  // },
  // {
  //   title: "线上支付返利余额",
  //   key: "onlineAmount",
  // },
  // {
  //   title: "市场返利余额",
  //   key: "mktAmount",
  // },
  {
    title: "备注",
    key: "remark",
  },
];
export default {
  data() {
    return {
      loading: false,
      columns,
      platformList: [],

      params: {
        pageSize: 10,
        page: 1,
        accType: "0",
        platformCode: "",
        retCode: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      shopWalletList: "wallet/getShopWalletList",
      shopInfoQueryList: "shop/getShopInfoQueryList",
    }),
  },
  created() {
    this.getList();
    this.getPlatform();
    // 门店接口（门店管理）
    this.$store.dispatch("shop/getShopInfoQueryList", { pageSize: 1000 });

    // setTimeout(() => {
    //   console.log(this.shopWalletList)
    // }, 2000)
  },
  methods: {
    getPlatform() {
      this.$api["sysPlatformQueryAll"]({}).then((res) => {
        if (res.code == "200") {
          this.platformList = res.data;
        }
      });
    },
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("wallet/getShopWalletList", this.params)
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 页码
    pageNumChange(pageNum) {
      this.params.page = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.params.pageSize = pageSize;
      // 页码变动触发pageNumChange
      if (this.params.page == 1) {
        this.getList();
      } else {
        this.params.page = 1;
      }
    },
    // 重置
    resetList() {
      this.params.page = 1;
      this.params.pageSize = 10;
      this.params.platformCode = "";
      this.params.retCode = "";
      this.getList();
    },
    // 添加
    create() {
      this.$router.push({
        path: "create",
        // query:
      });
    },
    // 导入
    importHandler() {},
    // 导出
    exportHandler() {},
    // 详情
    detail(row, index) {
      this.$router.push({
        path: "detail",
        query: {
          code: row.code,
        },
      });
    },
    deletehandler(row, index) {
      this.$store
        .dispatch("merchant/shopInfoDel", { code: row.code })
        .then((res) => {
          if (res.code == 200) {
            this.$Message.success("删除成功");
            this.getList();
          } else {
            this.$Message.error(res.message || "删除失败");
          }
        });
    },
    // 编辑
    edit(row, index) {
      this.$router.push({
        path: "create",
        query: {
          code: row.code,
        },
      });
    },
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/shop/wallet/cash.vue